import React from 'react';
import StatementPageTemplate from '../StatementPageTemplate';
import Icons from '../../../../../components/Common/Icons/Icons';
import { visaClassicStatementsAccordion, visaClassicStatementsCol } from '../Data';
import { SEARCH_SUGGESTIONS } from '../../Notices/Data';

function VisaClassicStatements() {
  return (
    <StatementPageTemplate
      icon={<Icons.UserCheck />}
      title="Visa Classic"
      tableProps={{
        data: visaClassicStatementsAccordion,
        tableCol: visaClassicStatementsCol,
      }}
      searchSuggestions={SEARCH_SUGGESTIONS}
    />
  );
}

export default VisaClassicStatements;
